import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const APP_STORE = "https://apps.apple.com/pt/app/luft-pilates-studio/id6761007459";
const GOOGLE_PLAY =
  "https://play.google.com/store/apps/details?id=pt.yogobooking.luftpilates&pcampaignid=web_share";

export default function AppStrip() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("luft-app-strip-dismissed")) {
      setDismissed(true);
      return;
    }
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const progress = total > 0 ? window.scrollY / total : 0;
      setVisible(progress > 0.55);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem("luft-app-strip-dismissed", "1");
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      data-testid="mobile-app-strip"
      aria-hidden={!visible}
    >
      <div className="bg-[var(--luft-ink)] text-[#F6F4EE] px-5 py-3.5 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="font-display italic text-[1.05rem] leading-tight">
            Reserva também na app
          </p>
          <p
            className="text-[#F6F4EE]/55 mt-0.5"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "0.58rem",
              letterSpacing: "0.22em",
              textTransform: "uppercase",
            }}
          >
            Lu.ft Pilates Studio
          </p>
        </div>
        <a
          href={APP_STORE}
          target="_blank"
          rel="noopener noreferrer"
          className="px-3 py-1.5 text-[0.62rem] uppercase tracking-[0.18em] border border-white/35 rounded-full hover:bg-white hover:text-[var(--luft-ink)] transition-colors"
          data-testid="strip-app-store"
          onClick={() =>
            trackEvent("app_store_click", {
              surface: "mobile",
              location: "app_strip",
              store: "app_store",
            })
          }
        >
          iOS
        </a>
        <a
          href={GOOGLE_PLAY}
          target="_blank"
          rel="noopener noreferrer"
          className="px-3 py-1.5 text-[0.62rem] uppercase tracking-[0.18em] border border-white/35 rounded-full hover:bg-white hover:text-[var(--luft-ink)] transition-colors"
          data-testid="strip-google-play"
          onClick={() =>
            trackEvent("google_play_click", {
              surface: "mobile",
              location: "app_strip",
              store: "google_play",
            })
          }
        >
          Android
        </a>
        <button
          onClick={dismiss}
          className="ml-1 p-1 text-white/55 hover:text-white transition-colors"
          aria-label="Fechar"
          data-testid="strip-dismiss"
        >
          <X size={16} strokeWidth={1.4} />
        </button>
      </div>
    </div>
  );
}
